<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        color="red"
        min-width="auto"
        offset-overflow
        :disabled="disabled"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-form ref="form">
                <v-text-field
                    class="shrink mt-md-2"
                    readonly
                    outlined
                    :label="labelText"
                    dense
                    :rules="[periodDateRule]"
                    required
                    v-bind="attrs"
                    v-on="on"
                    color="secondary lighten-1"
                    :disabled="disabled"
                >
                    <template v-slot:prepend-inner>
                        <v-icon class="mt-1 mr-1" size="18">mdi-calendar</v-icon>
                    </template>
                </v-text-field>
            </v-form>
        </template>
        <div class="primary darken-1">
            <div style="display: flex;">
                <v-date-picker
                    v-model="periodDate"
                    no-title
                    locale="pt-br"
                    range
                    :type="typeDateField"
                    :max="maxPeriodDate()"
                    :min="minPeriodDate()"
                    color="secondary lighten-1"
                >
                </v-date-picker>
                <div v-if="type === 'hourly'" class="pa-6" style="display: flex; flex-direction: column; justify-content: center; min-width: 160px;">
                    <time-picker-field
                        title="De"
                        :date="formatDate(sortedPeriodDate, 0)"
                        :hour="formatHour(sortedPeriodDate, 0)"
                        @changeHourDate="changeHourDate($event, 0)"
                    >
                    </time-picker-field>

                    <time-picker-field
                        title="Até"
                        :date="formatDate(sortedPeriodDate, 1)"
                        :hour="formatHour(sortedPeriodDate, 1)"
                        @changeHourDate="changeHourDate($event, 1)"
                    >
                    </time-picker-field>
                </div>
            </div>
            <div class="mr-3 pb-3" style="display: flex; justify-content: flex-end;">
                <v-btn
                    class="button-text"
                    text
                    color="secondary lighten-1"
                    @click="cancelDateSelected"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    class="button-text"
                    text
                    color="secondary lighten-1"
                    @click="applyDateSelected"
                    :disabled="periodDateRule !== true"
                >
                    Aplicar
                </v-btn>
            </div>
        </div>
    </v-menu>
</template>

<script>
import moment from 'moment';
import TimePickerField from './TimePickerField.vue';
export default {
    components: { TimePickerField },
    name: 'DateField',
    props:{
        type:{
            type: String,
            default: 'daily',
            validator: (value)=>{
                return ['daily', 'monthly', 'hourly'].indexOf(value) !== -1;
            }
        },
        disabled:{
            type: Boolean,
            default: false
        }
    },
    data:()=>({
        menu: false,
        periodDate: undefined,
        sortedPeriodDate: undefined,
    }),
    watch:{
        periodDate(value){
            if(value){
                this.sortedPeriodDate = this.orderPeriodDate(value);
            }
        }
    },
    computed:{
        labelText(){
            const stringFormat = this.type === 'daily' ? 'DD/MM/YYYY' : this.type === 'monthly' ? 'MM/YYYY' : 'DD/MM/YYYY HH:mm';

            if(this.periodDate){
                return `De ${moment(this.periodDate[0]).format(stringFormat)} a ${moment(this.periodDate[1]).format(stringFormat)}`;
            }
            return '';
        },

        periodDateRule(){

            if(this.periodDate){
                if(!this.periodDate.length || this.periodDate.length === 1) return 'Selecione um período.'
                const orderDate = this.orderPeriodDate(this.periodDate);
                const unitOfTime = this.type === 'monthly' ? 'months' : 'days';
                const max = this.type === 'monthly' ? 12 : this.type === "daily" ? 180 : 7;
                if(orderDate.length > 1 && moment(orderDate[1]).diff(moment(orderDate[0]), unitOfTime) > max){
                    const unit = this.type === "monthly" ? "meses" : "dias";
                    return `O período máximo deve ser ${max} ${unit}.`;
                }
            }
            return true;
        },

        typeDateField(){
            if(this.type === "monthly") return "month";
            return "date";
        }
    },
    methods:{
        cancelDateSelected(){
            this.menu = false;
            this.$emit('cancelDateSelected');
        },
        applyDateSelected(){
            this.menu = false;

            if(this.$refs.form.validate()){
                this.periodDate = this.orderPeriodDate(this.periodDate);
                this.$emit('applyDateSelected', this.periodDate);
            }
        },
        backOldDateValue(date){
            this.periodDate = date;
        },
        maxPeriodDate(){
            const stringFormat = this.type === 'daily' ? 'YYYY-MM-DD' : this.type === 'monthly' ? 'YYYY-MM' : 'YYYY-MM-DDTHH:mm';
            return moment().format(stringFormat);
        },
        minPeriodDate(){
            const stringFormat = this.type === 'daily' ? '2020-05-01' : this.type === 'monthly' ? '2020-05' : 'YYYY-MM-DDTHH:mm';
            if(this.periodDate){
                let ordereddate = this.orderPeriodDate(this.periodDate);
                const date = ordereddate.length > 1 ? moment(ordereddate[1]) : moment(ordereddate[0]);
                const min = date.clone().subtract(1, 'years');
                return min.format(stringFormat)
            }else{
                return moment().subtract(1, 'years').format(stringFormat);
            }

        },
        orderPeriodDate(date){
            const stringFormat = this.type === 'daily' ? 'YYYY-MM-DD' : this.type === 'monthly' ? 'YYYY-MM' : 'YYYY-MM-DDTHH:mm';
            const granularity = this.type === 'daily' ? 'days' : this.type === 'monthly' ? 'months' : 'hours';
            let initDate;
            let finalDate;

            if(date.length > 1){
                if(moment(date[0]).isBefore(moment(date[1]), granularity)){
                    initDate =  moment(date[0]).format(stringFormat);
                    finalDate = moment(date[1]).format(stringFormat);
                }else{
                    initDate = moment(date[1]).format(stringFormat);
                    finalDate = moment(date[0]).format(stringFormat);
                }

                return [initDate, finalDate];
            }

            return date;
        },
        formatDate(period, index){
            return period && period[index] ? moment(period[index]).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY");
        },
        formatHour(period, index){
            return period && period[index] ? moment(period[index]).format("HH:mm") : "00:00";
        },
        changeHourDate(hour, dateIndex){
            const date = moment(this.sortedPeriodDate[dateIndex]).format("YYYY-MM-DD");
            this.periodDate[dateIndex] = `${date}T${hour}`;
        }
    }
}
</script>
